import React, { createContext } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import { usePersistState, getPersistState, setPersistState } from "@common/hooks/persistState";

const getInitialState = (lang = "", oddsFormat = "decimal") => ({
  lang,
  oddsFormat,
});

export const PreferencesContext = createContext([getInitialState(), _.noop]);

let dispatcher = (newValue) => setPersistState("preferences", newValue);
let getValue = () => getPersistState(getInitialState(), "preferences");

export const getPreferencesContextValue = () => [getValue(), dispatcher];

export const PreferencesContextProvider = ({ config, lang, children }) => {
  const state = usePersistState(getInitialState(lang, config.odd.oddsFormat), "preferences");

  const [value, setValue] = state;

  getValue = () => value;
  dispatcher = setValue;

  return <PreferencesContext.Provider value={state}>{children}</PreferencesContext.Provider>;
};

PreferencesContext.propTypes = {
  children: PropTypes.node,
};
